import { render, staticRenderFns } from "./default.vue?vue&type=template&id=170955b4&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderComponent: require('/usr/src/app/components/HeaderComponent.vue').default,FormPopup: require('/usr/src/app/components/FormPopup.vue').default})
